import {optimizeImgUrl} from '@/common/util';

// 聚合页的主题tab配置
export const summaryTabList = [
    {
        label: '视频',
        name: 'video',
        icon: 'video-solid',
        routeName: 'homeV2',
        background: 'https://qiaojiang.bj.bcebos.com/fe/static/video/v2-bg-demo.mp4'
    }, {
        label: '图片',
        name: 'image',
        hideRole: 'digital_is_passport',
        routeName: 'homeV2',
        icon: 'image-solid'
    }, {
        label: '文案',
        name: 'text',
        hideRole: 'digital_is_passport',
        icon: 'text-square-solid',
        routeName: 'homeV2',
        background: 'https://qiaojiang.bj.bcebos.com/fe/static/video/v2-bg-demo.mp4'
    }, {
        label: '数字人',
        name: 'digitalhuman',
        icon: 'smiley-star-solid',
        routeName: 'homeV2',
        background: 'https://qiaojiang.bj.bcebos.com/fe/static/video/v2-bg-demo.mp4'
    }
];
// 聚合页内容卡片内容
export const summaryContentMap = {
    video: {
        mainCard: {
            thumbnail: 'https://qiaojiang.bj.bcebos.com/fe/static/images/summary/video-create-new-main.png',
            routeName: 'MashupCreateV2',
            hideRole: 'digital_is_passport',
            freeLimit: true,
            title: '一键成片',
            desc: '基于prompt、原始素材一键生成营销视频成片，同时支持自定义输入'
        },
        mainCardList: [
            {
                thumbnail: 'https://qiaojiang.bj.bcebos.com/fe/static/images/summary/ai-work-flowreal-main.png',
                routeName: 'videoWorkflowV2',
                title: 'AI创编大师',
                limitRole: 'digital_human_list',
                markType: 'new',
                markText: 'NEW',
                desc: '输入创意想法，智能生成爆款成片'
            },
            {
                thumbnail: 'https://qiaojiang.bj.bcebos.com/fe/static/images/summary/video-create-new-main.png',
                routeName: 'MashupCreateV2',
                hideRole: 'digital_is_passport',
                freeLimit: true,
                title: '一键成片',
                desc: '基于prompt、原始素材一键生成营销视频成片，同时支持自定义输入'
            }
        ],
        cardList: [{
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/video_small_fragment.png', 'resize,p_50'),
                routeName: 'SceneryImg2VideoV2',
                hideRole: 'digital_is_passport',
                freeLimit: true,
                title: '片段生成',
                authorizedRole: 'is_qingduo_uc_user',
                desc: '基于文本、图片生成视频，可用于片头、混剪等场景'
            },
            {
                thumbnail: 'https://qiaojiang.bj.bcebos.com/fe/static/images/summary/viral-fission-small-new2.png',
                routeName: 'ViralFissionV2',
                title: '爆款裂变',
                limitRole: ['digital_human_list', 'qingduo_hot_video_material', 'qingduo_hot_video_local'],
                markType: 'new',
                markText: 'NEW',
                desc: '智能替换爆款视频元素，批量衍生新素材'
            },
            {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/video_small_editor.png', 'resize,p_50'),
                routeName: 'VideoTemplateV2',
                title: '专业编辑器',
                desc: '支持视频在线编辑，可自定义视频效果'
            },
            {
                thumbnail: optimizeImgUrl('https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/shortHightLight.png', 'resize,p_50'),
                routeName: 'HighlightCreate',
                title: '短剧高光',
                limitRole: 'digital_human_list',
                // markType: 'new',
                // markText: 'NEW',
                desc: '批量上传短剧，生成营销视频'
            },
            {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/video_small_model.png', 'resize,p_50'),
                title: '模板视频',
                routeName: 'videoTplCreate',
                // authorizedRole: 'qingduo_image_digital',
                desc: '上传图片文案等素材即可快速生成视频'
            }
        ]
    },
    image: {
        mainCard: {
            thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/image_main.png', 'resize,p_50'),
            routeName: 'marketImageCreateV2',
            title: '一键出图',
            desc: '快速生成底图，支持叠加营销海报效果',
            anyMatch: {
                allowInnerUser: true,
                authorizedRole: ['digital_human_list']
            },
            freeLimit: true
        },
        mainCardList: [
            {
                thumbnail: optimizeImgUrl('https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/agent/agent-new.png', 'resize,p_80'),
                link: '/v3/user/${userid}/index',
                title: '图片Agent',
                desc: '全新体验，自然语言描述，多模态输入，自动规划生成高质量营销图',
                anyMatch: {
                    authorizedRole: ['digital_human_list']
                },
                // 互斥组，值相同、权限配置重复的话只显示一个；
                mutexGroup: 'imageAgent',
                freeLimit: true,
                externalTarget: '_self',
                markType: 'new',
                markText: 'NEW'
            },
            {
                thumbnail: optimizeImgUrl('https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/agent/agent-new.png', 'resize,p_80'),
                routeName: 'imageAgentV2',
                title: '图片Agent',
                desc: '全新体验，自然语言描述，多模态输入，自动规划生成高质量营销图',
                limitRole: 'qingduo_image_ip_thumbnail_generate',
                mutexGroup: 'imageAgent',
                freeLimit: true,
                markType: 'new',
                markText: 'NEW'
            },
            {
                thumbnail: optimizeImgUrl('https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/agent/image-new.png', 'resize,p_80'),
                routeName: 'marketImageCreateV2',
                title: '一键出图',
                desc: '快速生成底图，支持叠加营销海报效果',
                anyMatch: {
                    allowInnerUser: true,
                    authorizedRole: ['digital_human_list']
                },
                freeLimit: true
            }
        ],
        cardList: [
            {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/image_small_ipgenerate.png', 'resize,p_50'),
                title: 'IP封面生成',
                routeName: 'coverPictureV2',
                freeLimit: true,
                desc: '为视频生成IP封面，高品质高保真'
            }, {
                thumbnail: optimizeImgUrl('https://feed-image.baidu.com/0/pic/627917734_1213506831_-1364795312.png', 'resize,p_50'),
                title: '模板制图',
                routeName: 'templateV2',
                authorizedRole: 'digital_human_list',
                freeLimit: true,
                desc: '海量优质模板，支持营销图批量生产'
            }, {
                thumbnail: optimizeImgUrl('https://feed-image.baidu.com/0/pic/1978237502_219923540_-1173556818.png', 'resize,p_50'),
                title: '智能抠图',
                routeName: 'aiCutoutImageV2',
                freeLimit: true,
                desc: '保留图片主体内容，灵活应用于多种场景'
            }, {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/image_small_expand.png', 'resize,p_50'),
                routeName: 'aiExpandImageV2',
                title: '智能扩图',
                desc: '运用补图技术，将素材调整为任意尺寸'
            },
            {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/image_small_merge.png', 'resize,p_50'),
                routeName: 'stitchingImageCreateV2',
                title: '多图拼接',
                desc: '多张图片快速拼接，为您生成最优布局'
            }, {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/image_small_cut.png', 'resize,p_50'),
                routeName: 'cropImageCreateV2',
                title: '批量裁剪',
                desc: '支持批量裁切图片，高效实现组图投放'
            }
        ],
        panelList: [
            {
                routeName: 'hudongToolV2',
                title: '互动工具',
                authorizedRole: 'is_qingduo_uc_user'
            },
            // {
            //     routeName: 'imageEditorV2',
            //     title: '图片编辑器',
            //     authorizedRole: 'digital_human_list',
            //     hideRole: 'aigc_images_new'
            // },
            {
                routeName: 'newImageEditorV2',
                title: '图片编辑器',
                // markType: 'new',
                // markText: 'NEW',
                authorizedRole: 'digital_human_list'
            }
        ]
    },
    text: {
        mainCard: {
            thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/text_main.png', 'resize,p_50'),
            routeName: 'textCreateTitleV2',
            // markType: 'new',
            // markText: 'NEW',
            title: '一键生文',
            desc: '快速生成创意文案，支持个性化需求表达'
        },
        cardList: [
            {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/text_script.png', 'resize,p_50'),
                routeName: 'textCreateScriptV2',
                title: '口播文案生成',
                desc: '适配营销场景，生成符合表达习惯的口语化口播文案'
            },
            {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/text_shortplay.png', 'resize,p_50'),
                routeName: 'textCreateShortplayV2',
                title: '情景剧本生成',
                desc: '生成营销剧情、角色台词等剧本分镜信息，助力剧情类短视频场景创意'
            },
            // {
            //     thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/text_medium_script.png', 'resize,p_50'),
            //     routeName: '',
            //     markType: 'wait',
            //     markText: '敬请期待',
            //     title: 'Prompt改写',
            //     desc: '改写生成更丰富的prompt，助力ai创意表达',
            //     hideCard: true
            // },
            {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/wait_medium.png', 'resize,p_50'),
                routeName: '',
                isEmpty: true,
                title: '敬请期待',
                desc: '- -',
                hideCard: true
            }
        ]
    },
    digitalhuman: {
        mainCard: {
            thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/digital_main.png', 'resize,p_50'),
            routeName: 'HumanCreateV2',
            title: '形象定制',
            desc: '制作1：1真人虚拟数字分身'
        },
        cardList: [
            {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/digital_small_voice.png', 'resize,p_50'),
                routeName: 'VoiceCreateV2',
                title: '语音复刻',
                desc: '高度还原复制声音，音质清晰，声音流畅'
            }, {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/digital_small_imghuman.png', 'resize,p_50'),
                routeName: 'ImageMashupCreateV2',
                hideRole: 'digital_is_passport',
                title: '图片数字人',
                freeLimit: true,
                desc: '上传一张人物图，即可生成数字人播报'
            }, {
                thumbnail: 'https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/digital.png',
                // 跳转到 digital-agent 子应用（同域），userid 由 handleClickCard 运行时替换
                externalPath: '/digital-agent/user/{userid}/avatar-generator/new',
                anyMatch: {
                    authorizedRole: ['digital_human_list']
                },
                title: '商品数字人',
                desc: '商品图变真人讲解，电商营销更高效'
            },
            // {
            //     thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/digital_small_face.png', 'resize,p_50'),
            //     routeName: '',
            //     hideRole: 'digital_is_passport',
            //     markType: 'wait',
            //     markText: '即将上线',
            //     title: '智能换脸',
            //     desc: '一个原始拍摄视频与人脸图，自动人脸替换'
            // },
            {
                thumbnail: optimizeImgUrl('https://qiaojiang.bj.bcebos.com/fe/static/images/summary/wait_small.png', 'resize,p_50'),
                routeName: '',
                isEmpty: true,
                title: '敬请期待',
                desc: '- -'
            }
        ]
    }
};

const aicreateChildren = summaryTabList.map(tabItem => {
    let tabContent = summaryContentMap[tabItem.name];
    let tabChildren = [];
    if (tabContent.mainCardList) {
        tabContent.mainCardList.forEach(mainCartItem => {
            tabChildren.push({
                ...mainCartItem,
                title: mainCartItem.title,
                value: mainCartItem.routeName
            });
        });
    }
    else {
        tabChildren.push({
            ...tabContent.mainCard,
            title: tabContent.mainCard.title,
            value: tabContent.mainCard.routeName
        });
    }
    tabContent.cardList.forEach(cardItem => {
        tabChildren.push({
            ...cardItem,
            title: cardItem.title,
            value: cardItem.routeName
        });
    });
    if (tabContent.panelList) {
        tabContent.panelList.forEach(panelItem => {
            tabChildren.push({
                ...panelItem,
                title: panelItem.title,
                value: panelItem.routeName
            });
        });
    }
    return {
        ...tabItem,
        title: tabItem.label,
        children: tabChildren
    };
});

// 顶部header导航配置
export const navConfig = [
    {
        title: '生成',
        value: 'summaryPage',
        authorizedRole: 'digital_human_list',
        routeName: 'homeV2Default',
        children: aicreateChildren
    },
    {
        title: '发现',
        value: 'findV2',
        routeName: 'findV2Image',
        // head区导航显示名单
        authorizedRole: 'digital_human_list',
        hideRole: 'digital_is_passport',
        needWider: true,
        children: [
            {
                title: '生成灵感',
                icon: 'smiley-star-solid',
                children: [
                    {
                        title: '图片生成',
                        value: 'findV2Image',
                        anyMatch: {
                            allowInnerUser: true,
                            authorizedRole: ['digital_human_list']
                        }
                    },
                    {
                        title: '视频生成',
                        value: 'findV2Video',
                        authorizedRole: 'is_qingduo_uc_user'
                    }
                ]
            },
            {
                title: '创意灵感',
                icon: 'folder-download-solid',
                children: [
                    {
                        title: '视频灵感',
                        value: 'findV2Script',
                        authorizedRole: 'qingduo_scenery_image_generate_video',
                        forbidOuterUser: true
                    },
                    {
                        title: '视频灵感',
                        value: 'findV2ScriptNew',
                        authorizedRole: 'qingduo_image_digital'
                    }
                ]
            }
        ]
    },
    {
        title: '市场',
        value: 'marketV2',
        routeName: 'digitalHumanListV2',
        authorizedRole: 'digital_human_list',
        children: [
            {
                children: [
                    {
                        title: '数字人模特',
                        value: 'digitalHumanListV2'
                    },
                    {
                        title: '智能语音',
                        value: 'digitalVoiceListV2'
                    },
                    {
                        title: '视频模板',
                        value: 'digitalVideoTemplateV2'
                    },
                    {
                        title: '图片模板',
                        value: 'imageTemplateV2',
                        hideRole: 'digital_is_passport'
                    }
                    // {
                    //     title: '慧合平台',
                    //     link: 'https://join.baidu.com/advertiser/user/${userid}/demand',
                    //     markIcon: 'external-link'
                    // },
                    // {
                    //     title: '创意集市',
                    //     link: 'https://fuwu.baidu.com/magnum/user/1/create/list',
                    //     markIcon: 'external-link'
                    // }
                ]
            }
        ]
    },
    {
        title: '资产',
        value: 'assetsV2LibraryNew',
        routeName: 'assetsV2LibraryVideo',
        authorizedRole: 'digital_human_list',
        children: [
            {
                title: '投放库',
                icon: 'box-solid',
                children: [
                    {
                        title: '视频',
                        value: 'assetsV2LibraryVideo'
                    },
                    {
                        title: '图片',
                        value: 'assetsV2LibraryImage',
                        hideRole: 'digital_is_passport'
                    },
                    {
                        title: '文案',
                        value: 'assetsV2LibraryText',
                        hideRole: 'digital_is_passport'
                    }
                ]
            },
            {
                title: '原料库',
                icon: 'folder-download-solid',
                children: [
                    {
                        title: '视频',
                        value: 'assetsV2LibraryRawVideo'
                    },
                    {
                        title: '图片',
                        value: 'assetsV2LibraryRawImage',
                        hideRole: 'digital_is_passport'
                    },
                    {
                        title: '脚本',
                        value: 'assetsV2LibraryScript'
                    }
                ]
            }
        ]
    },
    {
        title: '诊断',
        value: 'analysisV2',
        routeName: 'diagnoseAfterPut',
        // head区导航显示名单
        authorizedRole: 'digital_human_list',
        hideRole: 'digital_is_passport',
        needWider: true,
        children: [
            {
                title: '投后诊断',
                icon: 'trend-monitor-solid',
                children: [
                    {
                        title: '单素材诊断',
                        value: 'diagnoseAfterPut',
                        authorizedRole: 'digital_human_list',
                        forbidOuterUser: true
                    }
                ]
            },
            {
                title: '投前分析',
                icon: 'shield-wave-solid',
                children: [
                    {
                        title: '视频预检',
                        value: 'videoPreCheck',
                        authorizedRole: 'is_qingduo_uc_user'
                    }
                ]
            }
        ]
    }
];

// 借用消息弹窗的组件功能，mock消息数据，触发弹窗；
export const oldToNewTipDialogData = {
    title: '擎舵新版迁移通知',
    content: '<span class="header-v1-tip-messageDialog-content">'
            + '<h5><img src="https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/old-message-box-title-text_x2.png"/></h5>'
            + '<span>亲爱的用户</span>'
            + '<span>感谢您一直以来对擎舵的支持与厚爱！为了给您提供更加优质、高效的服务，'
            + '擎舵已完整迁移至新版，2024年12月23日起将默认使用新版本，届时旧版所有功能均可在新版继续使用。'
            + '新版拥有焕然一新的界面、全新升级的能力、简单便捷的交互，'
            + '在这里可以一键生成你的创意。'
            + '</span>'
            + '<span>探索无限创意，尽在全新擎舵2.0！</span>'
        + '</span>',
    jsonContent: {
        'overlayClass': 'message-dialog-full-image no-header old-header-newtip-messageDialog',
        'confirmClass': 'ai-button',
        'confirmText': '前往新版体验 >>',
        'confirmRoute': 'homeV2Default'
    }
};
